<script>
    import { tweened } from 'svelte/motion';
    export let animee;

    $: anim = tweened(0, {
        duration: 400
    });
    $: fertig = anim.set(animee);
</script>

<span>{$anim.toLocaleString('de-DE',{ minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
